import { Button, Grid, Typography } from "@mui/material"
import { formatUserName } from "../Utils/String"
import { KaziAvatar } from "./Kazi/KaziAvatar"
import { Talent } from "../Types/Talent"
import { useNavigate } from "react-router-dom";
import { useKaziNavigate } from "../Hooks/useKaziNavigate";

interface Props {
    locator: string;
    title: string;
    first_name: string;
    last_name: string;
    profile_picture?: string;
    showNavigation?: boolean 
}
export const TalentPreview = ({ locator, first_name, last_name, title, showNavigation = false }: Props) => {
    /* ******************** Hooks ******************** */
    const { navigateToTalent } = useKaziNavigate();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleClick = () => {
        navigateToTalent(locator)
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid  flex={1} display={'flex'} flexDirection={'row'} gap={2}>
            <Grid display={'flex'} flexDirection={'column'}> 
                <KaziAvatar 
                    locator={locator} 
                    first_name={first_name} 
                    last_name={last_name} 
                    width='32px'
                />
            </Grid>
            <Grid  display={'flex'} flexDirection={'column'}>
                <Typography variant='body-medium'>{formatUserName(first_name, last_name)}</Typography>
                <Typography variant='body-smaller'color={'black.300'}>{title ?? 'N/A'}</Typography>
            </Grid>
            {
                showNavigation &&
                <Grid flex={1} justifyContent={'flex-end'} display={'flex'} flexDirection={'row'} gap={'16px'} alignItems={'center'}>
                    <Button variant='text' sx={{fontWeight: 'bold'}} onClick={handleClick}>View Profile</Button>
                </Grid>
            }
        </Grid>
    )
}